var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgApple = function SvgApple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.71 0C8.905.034 7.93.542 7.351 1.224c-.52.607-.972 1.574-.85 2.502.9.07 1.815-.461 2.375-1.144.559-.684.937-1.634.834-2.582m-.227 15.978c1.091-.02 1.782-1 2.45-1.985.733-1.08 1.056-2.126 1.104-2.282l.006-.018-.004-.002c-.105-.043-2.125-.871-2.145-3.267-.02-1.978 1.543-2.962 1.716-3.07l.012-.009c-.94-1.388-2.406-1.579-2.928-1.6-.763-.078-1.503.216-2.107.456-.384.153-.714.284-.96.284-.274 0-.612-.136-.992-.288-.497-.199-1.065-.426-1.652-.415-1.359.02-2.612.797-3.312 2.026-1.413 2.474-.362 6.14 1.014 8.145.674.981 1.475 2.085 2.529 2.046.47-.02.805-.163 1.151-.312.4-.172.816-.35 1.474-.35.626 0 1.022.173 1.403.339.365.16.716.312 1.24.302",
    clipRule: "evenodd"
  })));
};
export default SvgApple;